import { Routes } from '@angular/router';
import { authGuard, pageNotFoundGuard, systemMaintenanceGuard, tokenGuard } from './guards/auth.guard';
import { UnAuthorizedComponent } from './shared/components/un-authorized/un-authorized.component';
import { SystemMaintenanceComponent } from './shared/components/system-maintenance/system-maintenance.component';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from '@auth0/auth0-angular';

export const routes: Routes = [
  {
    path: '', canActivate: [ AuthGuard, tokenGuard, pageNotFoundGuard ], component: LayoutComponent, children: [
      {
        path: 'supplier-dashboard',
        loadChildren: () => import('./supplier-dashboard/supplier-dashboard.routes').then(m => m.supplierDashboardRoutes),
        canActivate: [ authGuard ]
      },
      {
        path: 'buyer-dashboard',
        loadChildren: () => import('./buyer-dashboard/buyer-dashboard.routes').then(m => m.buyerDashboardRoutes),
        canActivate: [ authGuard ]
      },
      {
        path: 'summary',
        loadChildren: () => import('./summary/summary.routes').then(m => m.summaryRoutes),
        canActivate: [ authGuard ]
      },
      {
        path: 'price-establishment',
        loadChildren: () => import('./price-establishment/price-establishment.routes').then(m => m.priceEstablishmentRoutes),
        // canActivate: [ authGuard ]
      },
      {
        path: 'notification',
        loadChildren: () => import('./notification/notification.routes').then(m => m.notificationRoutes),
        canActivate: [ authGuard ]
      },
      {
        path: 'promotion-detail',
        loadChildren: () => import('./promotion-details/promotion-details.routes').then(m => m.promotionDetailsRoutes),
        canActivate: [ authGuard ],
      },
      {
        path: 'proposal-detail',
        loadChildren: () => import('./proposal-details/proposal-details.routes').then(m => m.proposalDetailsRoutes),
        canActivate: [ authGuard ]
      },
      {
        path: 'manage-labels',
        loadChildren: () => import('./manage-labels/manage-labels.routes').then(m => m.manageLabelsRoutes),
        canActivate: [ authGuard ]
      },
      {
        path: 'manage-customer-group',
        loadChildren: () => import('./manage-customer-groups/manage-customer-groups.routes').then(m => m.manageCustomerGroupsRoutes),
        canActivate: [ authGuard ]
      },
      {
        path: 'promotion-phase-calender',
        loadChildren: () => import('./promotion-phase-calender/pahse-calender.routes').then(m => m.phaseCalenderRoutes),
        canActivate: [ authGuard ]
      },
      {
        path: 'rule-editor',
        loadChildren: () => import('./rule-editor/rule-editor.routes').then(m => m.ruleEditorRoutes),
        canActivate: [ authGuard ]
      },
      {
        path: 'manage-invoice',
        loadChildren: () => import('./manage-invoice/manage-invoice.routes').then(m => m.invoiceRoutes),
        canActivate: [ authGuard ]
      },
      {
        path: 'customer-group-requests',
        loadChildren: () => import('./customer-group-request/customer-groups-request.routes').then(m => m.customerGroupRequest),
        canActivate: [ authGuard ]
      }
    ]
  },
  { path: 'unauthorised', component: UnAuthorizedComponent, canActivate: [ pageNotFoundGuard ] },
  { path: 'system-maintenance', component: SystemMaintenanceComponent, canActivate: [ systemMaintenanceGuard ] },
  { path: '**', redirectTo: 'unauthorised', pathMatch: 'full' }
];
